import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

import CircularProgress from '@material-ui/core/CircularProgress';
import { ReactComponent as GoogleLogo } from '../../assets/images/icons/google_g_logo.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
  progress: {
    overflow: 'hidden',
    margin: 'auto',
    marginTop: theme.spacing(2),
    zIndex: 1000,
    position: 'absolute',
  },
  google: {
    position: 'absolute',
    top: '-1px',
  },
}));

export default function CircularLoadingGoogleSso(props) {
  const classes = useStyles();
  const { size, thickness } = props;

  return (
    <Box className={classes.root}>
      <CircularProgress
        className={classes.progress}
        size={size}
        thickness={thickness}
      />
      <GoogleLogo className={classes.google} />
    </Box>
  );
}

CircularLoadingGoogleSso.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  thickness: PropTypes.number.isRequired,
};
CircularLoadingGoogleSso.defaultProps = {
  size: 40,
};
